import {
  initTracerError,
  initTracerErrorAsyncStack,
  initTracerErrorUploader,
  initTracerSessionUploader,
  ITracerUploaderConfig,
} from '@apptracer/sdk'

const config: ITracerUploaderConfig = {
  versionName: `builddocs-js-${process.env.NODE_ENV || process.env.NX_ENV}`,
  versionCode: 1,
  appToken: process.env.NX_APPTRACER_API_TOKEN!,
  environment: process.env.NODE_ENV || process.env.NX_ENV,
}

export const tracerError = initTracerError({
  handleOtherErrorDataType: true,
})
initTracerErrorUploader(config)
initTracerSessionUploader(config)
initTracerErrorAsyncStack()

export function ApptracerProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>
}
